import { motion } from "framer-motion";
import { Target, Users, BarChart3 } from "lucide-react";

export function AdvantagesSection() {
  const advantages = [
    {
      icon: Target,
      title: "End-to-end execution",
      description: "Complete implementation from concept to deployment and results measurement",
      color: "orange-600"
    },
    {
      icon: Users,
      title: "Hybrid marketing + dev team",
      description: "Combined team of marketing experts and developers for comprehensive solutions",
      color: "orange-500"  
    },
    {
      icon: BarChart3,
      title: "Data-driven optimization",
      description: "Performance optimization based on real data and detailed analytics insights",
      color: "orange-700"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Competitive Advantages
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-orange-500 to-orange-700 mx-auto mb-8"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Key differentiators that help AdHub create superior value
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {advantages.map((advantage, index) => (
            <motion.div
              key={advantage.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="text-center group"
            >
              <div className={`inline-flex p-6 rounded-full mb-6 transition-transform duration-300 group-hover:scale-110 ${
                advantage.color === 'orange-600' ? 'bg-orange-600/20 group-hover:bg-orange-600/30' :
                advantage.color === 'orange-500' ? 'bg-orange-500/20 group-hover:bg-orange-500/30' : 
                'bg-orange-700/20 group-hover:bg-orange-700/30'
              }`}>
                <advantage.icon className={`w-8 h-8 ${
                  advantage.color === 'orange-600' ? 'text-orange-400' :
                  advantage.color === 'orange-500' ? 'text-orange-400' : 'text-orange-400'
                }`} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">
                {advantage.title}
              </h3>
              <p className="text-gray-300 leading-relaxed text-lg">
                {advantage.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}